import { useState, useEffect } from 'react';
import { Button, Col, Container, Image, Modal, Row } from 'react-bootstrap';
import { useGoogleLogin, useGoogleLogout } from 'react-google-login';
import { FaFacebookF } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import { useHistory } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import logo from '../../../assets/logo_stride.png';
import { configService } from '../../../config/configureApi';
import { AuthActionEnum, ErrorMessageEnum } from '../../../enums/app.enum';
import { useAuthState } from '../../../states/auth.state';
import CloseIcon from '../close-icon/close-icon.component';
import '../login-modal/login-modal.component.scss';
import TermConditionModal from '../term-condition-modal/term-condition-modal.component';
import PrivacyPolicyModal from '../privacy-pocily-modal/privacy-pocily-modal.component';

const GOOGLE_API_KEY = configService.googleLoginApiKey || '';

/**
 * Modal delect
 * @param {*} props Modal props
 * @param {*} props.onHide callback function when close modal
 * @returns
 */
const SignupModal = (props: any) => {
  const history = useHistory();
  const authState = useAuthState();
  const [showTC, setshowTC] = useState(false);
  const [showPrivacy, setshowPrivacy] = useState(false);
  const { addToast } = useToasts();

  const handleLoginG = (res: any) => {
    authState.loginG(res.accessToken).then((loginRes) => {
      props.onHide();
      if (props.pathto) history.push(props.pathto);
    });
  };

  const { signIn } = useGoogleLogin({
    onSuccess: handleLoginG,
    onFailure: (err) => {
      console.log(err);
    },
    clientId: GOOGLE_API_KEY,
    isSignedIn: false,
    accessType: 'offline',
  });

  const { signOut } = useGoogleLogout({
    clientId: GOOGLE_API_KEY,
    onLogoutSuccess: () => {},
    onFailure: () => {},
  });

  const handleLoginFB = async () => {
    window.FB.login(
      (res: any) => {
        if (!res.authResponse) {
          // console.log('login fb fail')
          addToast(ErrorMessageEnum.loginFbFail, { appearance: 'error' });
        } else {
          authState.loginFB(res.authResponse.accessToken).then((loginRes) => {
            props.onHide();
            if (props.pathto) history.push(props.pathto);
          });
        }
      },
      { scope: 'email,public_profile' }
    );
  };

  const handleSignupByEmail = () => {
    props.onHide(AuthActionEnum.OPEN_SIGN_UP_BY_EMAIL);
  };

  const handleOpenLogin = () => {
    props.onHide(AuthActionEnum.OPEN_LOGIN);
  };

  return (
    <Modal {...props} animation={false} centered>
      <Modal.Body className="text-center">
        <CloseIcon onClicked={props.onHide} />
        <Container>
          <Row>
            <Col>
              <Image src={logo} width="300" className="my-4" />
              <div>
                <p className="text-14">
                  By registering to this website, you accept our{' '}
                  <span
                    className="text-primary pointer fw-7"
                    onClick={() => setshowTC(true)}
                  >
                    Terms of Use{' '}
                  </span>
                  and our{' '}
                  <span
                    className="text-primary pointer fw-7"
                    onClick={() => setshowPrivacy(true)}
                  >
                    Privacy Policy
                  </span>
                </p>
              </div>
              <div className="d-flex flex-column justify-content-center px-md-6 mt-6">
                <Button
                  variant="facebook"
                  block
                  onClick={handleLoginFB}
                  className="py-2 btn-signup"
                >
                  <FaFacebookF size={23} /> <span>Sign up with Facebook</span>
                </Button>
                <div
                  className={`btn btn-google btn-block btn-outline mt-2 py-2 btn-signup`}
                  onClick={signIn}
                >
                  <FcGoogle size={23} />{' '}
                  <b style={{ color: '#7C7C7C' }}>Sign up with Google</b>
                </div>
                <Button
                  variant="danger"
                  block
                  className="mt-2 py-2 btn-signup"
                  onClick={handleSignupByEmail}
                >
                  Sign up with email
                </Button>
              </div>
              <div className="text-center text-14 mt-4">
                <i>
                  Your booking information will be saved to yọur new account
                </i>
              </div>
              <div
                className="d-flex justify-content-center mb-4 mt-2"
                style={{
                  fontSize: '14px',
                  fontWeight: 600,
                  color: '#A6A6A6',
                  letterSpacing: '0.86px',
                }}
              >
                Already had an account?&nbsp;
                <span
                  className="text-primary pointer fw-7"
                  onClick={handleOpenLogin}
                >
                  Login
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      {showTC && (
        <TermConditionModal
          show={showTC}
          onHide={() => setshowTC(false)}
          onOk={() => setshowTC(false)}
        />
      )}
      {showPrivacy && (
        <PrivacyPolicyModal
          show={showPrivacy}
          onHide={() => setshowPrivacy(false)}
          onOk={() => setshowPrivacy(false)}
        />
      )}
    </Modal>
  );
};

export default SignupModal;
